<template>
    <div>
        <table class="table">
            <template v-if="enrollment.is_course_enrollment">
                <tr class="log-row" v-for="row in log" >
                    <td style="width: 10px;">
                        <b-tag type="is-info" v-if="content.units">
                            <i class="fas fa-check fa-fw mr-2"></i><strong class="has-text-white">{{ calcUnits(row.mins) }}</strong> {{ enrollment.application.cert.certification.unit_title }}
                        </b-tag>
                        <b-tag type="is-info" v-else>
                            <i class="fas fa-check fa-fw mr-2"></i><strong class="has-text-white">{{ row.minutes }}</strong> Minutes
                        </b-tag>
                    </td>
                    <td>
                        <div class="">{{ row.start_date | moment('dddd, MMMM Do, YYYY, h:mm A') }} - {{ row.end_date | moment('h:mm A') }}</div>
                    </td>
                    <td class="has-text-right" v-if="content.units">{{ row.mins }} Minutes</td>
                </tr>
            </template>
            <template v-else>
                <tr class="log-row" v-for="(row, index) in log">
                    <td style="width: 10px;">
                        <b-tag type="is-info" v-if="content.units">
                            <i class="fas fa-check fa-fw mr-2"></i><strong class="has-text-white">{{ calcUnits(row.minutes) }}</strong> {{ enrollment.application.cert.certification.unit_title }}
                        </b-tag>
                        <b-tag type="is-info" v-else>
                            <i class="fas fa-check fa-fw mr-2"></i><strong class="has-text-white">{{ row.minutes }}</strong> Minutes
                        </b-tag>
                    </td>
                    <td>
                        <div class="log-title">{{ row.session.title }}</div>
                        <div class="log-date">{{ row.start_at | moment('dddd, MMMM Do, YYYY, h:mm A') }} - {{ row.end_at | moment('h:mm A') }}</div>
                    </td>
                    <td class="has-text-right" v-if="content.units">{{ row.minutes }} Minutes</td>
                </tr>
            </template>
        </table>
    </div>
</template>

<script>
    export default {
        components: {},
        props: ['content', 'component', 'enrollment'],
        computed: {
            log() {
                if (!this.enrollment) return [];
                let log = this.enrollment.regApplication.log_snapshot;

                if (this.enrollment.is_course_enrollment) {
                    log.sort(function(a, b) {
                        return new Date(b.start_date) - new Date(a.start_date);
                    });

                    log = log.filter(function(entry) {
                        return entry.mins > 0;
                    });
                } else {
                    log.sort(function(a, b) {
                        return new Date(b.start_at) - new Date(a.start_at);
                    });
                }
                return log.reverse();
            }
        },
        methods: {
            calcUnits(minutes) {
                let cert = this.enrollment.application.cert.certification;
                let units = minutes / cert.unit_ratio;
                if (cert.unit_round_to) {
                    units = Math.floor(minutes / cert.unit_round_to) * cert.unit_round_to;
                }
                return units.toFixed(2);
            },
        }
    };
</script>

<style lang="scss" scoped>
    .log-row {

        .log-title {
            margin-top: 2px;
            font-size: 1em;
            font-weight: bold;
        }

        .log-date {
            margin-top: 5px;
            font-size: 0.8em;
        }

        td {
            border-color: #eaeaea;
            padding: 15px 10px;
        }

        &:last-child td {
            border: none;
        }
    }
</style>
